import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, BookOpenIcon, UsersIcon, GlobeIcon, ShieldCheckIcon, LandmarkIcon } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function WhatThisMakesPossible() {
  const {
    t,
    tArray
  } = useLanguage();
  const featuresData = tArray<{
    title: string;
    desc: string;
  }>('whatThisMakesPossible.features');
  const icons = [<HeartIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-208" data-mp="19ah61be97tpi" />, <BookOpenIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-209" data-mp="14acqbnl6730c" />, <UsersIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-210" data-mp="14bxl9ebecnyq" />, <GlobeIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-211" data-mp="1iangeoenodkg" />, <ShieldCheckIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-212" data-mp="1ibfafuslu38m" />, <LandmarkIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-213" data-mp="1d9zs4ahtaatx" />];
  const features = featuresData.map((f, i) => ({
    ...f,
    icon: icons[i % icons.length]
  }));
  return <section className="py-24 md:py-32 bg-ivory" data-id="element-214" data-mp="2oqg9i9cxf1jf">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-215" data-mp="2opoi7aqd3pyy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-216" data-mp="1vtdjs7uzk8kc">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-4" data-id="element-217" data-mp="1c4uxby1d799c">
            {t('whatThisMakesPossible.title1')}{' '}
            <span className="text-saffron italic" data-id="element-218" data-mp="1h367k9vknls3">
              {t('whatThisMakesPossible.title2')}
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-219" data-mp="1m17qmuszzl3k">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-marble p-8 rounded-sm border border-gold/10 hover:border-gold/30 transition-colors shadow-sm hover:shadow-md flex flex-col items-start" data-id="element-220" data-mp="tevevu014sew" data-mpi={idx}>
              <div className="text-saffron mb-6 bg-ivory p-4 rounded-full shadow-sm" data-id="element-221" data-mp="7eo2sw74c75f">
                {feature.icon}
              </div>
              <h3 className="font-heading text-2xl text-navy mb-3" data-id="element-222" data-mp="3enpjevra1zy">
                {feature.title}
              </h3>
              <p className="text-navy/70 leading-relaxed" data-id="element-223" data-mp="cd946yy3wwvg">{feature.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}